import { render, staticRenderFns } from "./DocShow.vue?vue&type=template&id=236424aa&scoped=true&"
import script from "./DocShow.vue?vue&type=script&lang=js&"
export * from "./DocShow.vue?vue&type=script&lang=js&"
import style0 from "./DocShow.vue?vue&type=style&index=0&id=236424aa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236424aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VSimpleCheckbox,VSpacer,VTextField})
